/**
 * 脚本动作模板集合
 */

export const scriptActionSimpleTemplate = `// 简单脚本动作示例
function execute(context) {
    console.log('执行简单动作')
    // 在这里添加你的动作逻辑
}

export { execute }`

export const scriptActionAdvancedTemplate = `// 高级脚本动作示例
function execute(context) {
    const logger = context.logger
    logger.log('执行高级动作')

    // 获取节点信息
    const node = context.node
    if (node) {
        logger.log('节点信息:', node)
        // 执行节点操作
        node.click()
    }
}

function cleanup(context) {
    context.logger.log('清理资源')
}

export { execute, cleanup }`

export const scriptActionFullTemplate = scriptActionAdvancedTemplate
